import React from 'react';
import { Flex, Spinner } from '@chakra-ui/react';

export default () => (
  <Flex width="100%" height="100%" alignItems="center" justifyContent="center">
    <Spinner size="lg" />
  </Flex>
);
